<div mat-dialog-title class="dialog-header">
  <h2>{{ previewPageId ? 'Preview Page' : 'Preview' }}</h2>
  <button mat-icon-button [mat-dialog-close] aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="form-with-logo">
  <app-member-logo-name [logoUrl]="logoUrl"></app-member-logo-name>
  <div class="container">
    @if (isSurvey) {
      <survey [inPreviewMode]="true" [previewFormId]="form?.id"></survey>
    } @else {
      @if (!isApplicationSubmitted) {
        <app-application
          [previewFormId]="form?.id"
          [previewPageId]="previewPageId"
          [onPreviewSubmit]="submitApplication"
        ></app-application>
      }
      @if (isApplicationSubmitted) {
        <app-application-confirmation
          [previewForm]="form"
        ></app-application-confirmation>
      }
    }
  </div>
</div>
